// extracted by mini-css-extract-plugin
module.exports = {"dMenuItemWrapper":"desktop-menu_dMenuItemWrapper__9w0_5","dMenuItem":"desktop-menu_dMenuItem__OKLC8","dMenuItemActive":"desktop-menu_dMenuItemActive__fQJj2"};